import { useBreadcrumb } from '../hooks/useBreadcrumb';

const HomeLink = () => {
	const { blockClass, homeIconSize } = useBreadcrumb();

	const renderClass = () => {
		return (
			blockClass &&
			`link--${blockClass} homeLink--${blockClass} vtex-breadcrumb-1-x-link--${blockClass} vtex-breadcrumb-1-x-homeLink--${blockClass}`
		);
	};

	return (
		<a
			onClick={() => (window.location.hash = 'search-1')}
			className={`link homeLink vtex-breadcrumb-1-x-link vtex-breadcrumb-1-x-homeLink ${renderClass()} dib pv1 link ph2 c-muted-2 hover-c-link v-mid`}
		>
			<svg
				fill="none"
				width={homeIconSize}
				height={homeIconSize}
				viewBox="0 0 16 16"
				className={`homeIcon ${blockClass ? `homeIcon--${blockClass} vtex-breadcrumb-1-x-homeIcon--${blockClass}` : ''} vtex-breadcrumb-1-x-homeIcon`}
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="nav-home">
					<path
						d="M 15.475000000000001 6.686111111111111 L 14.222222222222221 5.661111111111111 V 2.888888888888889 c 0 -0.12222222222222223 -0.1 -0.2222222222222222 -0.2222222222222222 -0.2222222222222222 h -0.8888888888888888 c -0.12222222222222223 0 -0.2222222222222222 0.1 -0.2222222222222222 0.2222222222222222 v 1.6805555555555556 L 8.705555555555556 1.1416666666666666 c -0.4083333333333333 -0.3361111111111111 -1 -0.3361111111111111 -1.4083333333333334 0 L 0.5249999999999999 6.686111111111111 c -0.09444444444444444 0.07777777777777778 -0.10833333333333334 0.21666666666666667 -0.030555555555555558 0.3138888888888889 l 0.5638888888888889 0.6888888888888889 c 0.07777777777777778 0.09444444444444444 0.21666666666666667 0.10833333333333334 0.3138888888888889 0.030555555555555558 l 0.4083333333333333 -0.3333333333333333 V 12.88888888888889 c 0 0.24444444444444446 0.2 0.4444444444444444 0.4444444444444444 0.4444444444444444 h 4.666666666666667 c 0.12222222222222223 0 0.2222222222222222 -0.1 0.2222222222222222 -0.2222222222222222 V 9.555555555555555 h 1.7777777777777777 v 3.5555555555555554 c 0 0.12222222222222223 0.1 0.2222222222222222 0.2222222222222222 0.2222222222222222 h 4.666666666666667 c 0.24444444444444446 0 0.4444444444444444 -0.2 0.4444444444444444 -0.4444444444444444 V 7.383333333333334 l 0.4083333333333333 0.3333333333333333 c 0.09444444444444444 0.07777777777777778 0.2361111111111111 0.06388888888888888 0.3138888888888889 -0.030555555555555558 l 0.5638888888888889 -0.6888888888888889 c 0.07222222222222223 -0.09444444444444444 0.058333333333333334 -0.23333333333333334 -0.036111111111111115 -0.3111111111111111 Z M 12.88888888888889 12 h -2.6666666666666665 V 8.444444444444445 c 0 -0.12222222222222223 -0.1 -0.2222222222222222 -0.2222222222222222 -0.2222222222222222 H 6 c -0.12222222222222223 0 -0.2222222222222222 0.1 -0.2222222222222222 0.2222222222222222 v 3.5555555555555554 h -2.6666666666666665 V 6.291666666666667 l 4.747222222222223 -3.888888888888889 c 0.08055555555555555 -0.06666666666666667 0.2 -0.06666666666666667 0.28055555555555556 0 l 4.747222222222223 3.888888888888889 V 12 Z"
						fill="currentColor"
					/>
				</g>
			</svg>
		</a>
	);
};

export default HomeLink;
